import React from "react";
import NewPasswordSuccessPage from "./new-password-success.page";
import { useSelector } from "react-redux";

function NewPasswordSuccessContainer(){
  const lang = useSelector(state => state.constant.languages);
  return <NewPasswordSuccessPage lang={lang}/>
}

export default NewPasswordSuccessContainer